import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Icon from "@/components/UI/Icon.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ImageZoomButton',
  props: {
    theme: { default: 'light' }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["image-zoom-button", [_ctx.theme]])
  }, [
    _createVNode(Icon, {
      name: "maximize",
      size: 16,
      color: _ctx.theme === 'light' ? '#FFF' : '#363739'
    }, null, 8, ["color"])
  ], 2))
}
}

})